import styled from 'styled-components';

import { style } from '@genially/design-system';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: size.units(2),

  // No width left to split below sm: one option per row.
  ...style.mixins.responsive.sm.downward({
    gridTemplateColumns: '1fr',
  }),
}));
